import React from 'react'
import {
    MdMessage,
    MdPeople,
    MdPermContactCalendar,
    MdRouter,
    MdSmsFailed,
    MdWifi,
    MdTv,
} from "react-icons/md";

import {
    CgListTree,
} from "react-icons/cg";

export const structureAdmin = [
    {
        id: 0,
        label: "Gateways",
        link: "/gateway",
        icon: <MdWifi/>,
    },
    {
        id: 156,
        label: "Mi Panel",
        link: "/dashboard",
        icon: <MdTv/>,
    },
    {
        id: 2,
        label: "Mis Usuarios",
        link: "/usuarios",
        icon: <MdPeople/>,
    },
    {
        id: 8,
        label: "Mis Dispositivos",
        icon: <MdRouter size={"30px"}/>,
        link: "/dispositivos",
    },
    {
        id: 9,
        label: "Mi Organización",
        icon: <CgListTree/>,
        link: "/grupos",
    },
    {
        id: 19,
        label: "Mis Alertas",
        icon: <MdSmsFailed/>,
        link: "/alertas",
    },
]
